import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { BaseEnumItemByIdPipe } from '@app/pipes/base-enum-item-by-id.pipe';
import { GenericProjectStore } from '@app/stores/projects/generic-project.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';
import {
  TableColumn,
  TableComponent,
} from '@app/ui-components/table/table.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NameConnectionFormComponent } from '../../../components/project-details/name-connection-form/name-connection-form.component';
import { NotCompletedLoanDisplayComponent } from '../../../components/project-details/not-completed-loan-display/not-completed-loan-display.component';
import { ApplicableInterestRateRowData } from './procet-details-section-g.models';

@Component({
  selector: 'app-project-details-section-g',
  imports: [
    BaseEnumItemByIdPipe,
    CommonModule,
    TranslatePipe,
    CardComponent,
    LabeledContentComponent,
    TableComponent,
    InfoLabelComponent,
    NameConnectionFormComponent,
    NotCompletedLoanDisplayComponent,
  ],
  templateUrl: './project-details-section-g.component.html',
  styleUrl: './project-details-section-g.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDetailsSectionGComponent implements AfterViewInit {
  genericProjectStore = inject(GenericProjectStore);
  projectDetails = input.required<ProjectPublicResponse>();
  @ViewChild('percentColumnTemplateRef')
  percentColumnTemplate?: TemplateRef<unknown>;
  protected translationKey = 'projectDetails.sectionG.';

  protected columns: TableColumn<ApplicableInterestRateRowData>[] = [];
  rowsData = computed(() => {
    return this.projectDetails().interestRates.interest.map((interest) => ({
      ivestedAmount: interest.amount,
      yearlyInterest: interest.interest,
      fullIntervallInterest: interest.interest * (interest.amount / 100),
    })) as ApplicableInterestRateRowData[];
  });
  constructor() {}

  ngAfterViewInit(): void {
    this.columns = [
      {
        key: 'ivestedAmount',
        label: 'Amount',
      },
      {
        key: 'yearlyInterest',
        label: 'yearlyInterest',
        template: this.percentColumnTemplate,
      },
      {
        key: 'fullIntervallInterest',
        label: 'fullIntervallInterest',
      },
    ];
  }
}
